export default {"src":"/_next/static/media/class-material.269658e9.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};